import { render, staticRenderFns } from "./Aliados.vue?vue&type=template&id=6544a34b"
import script from "./Aliados.vue?vue&type=script&lang=js"
export * from "./Aliados.vue?vue&type=script&lang=js"
import style0 from "./Aliados.vue?vue&type=style&index=0&id=6544a34b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports